import { render, staticRenderFns } from "./comp4.vue?vue&type=template&id=28c300ce&scoped=true"
import script from "./comp4.vue?vue&type=script&lang=ts"
export * from "./comp4.vue?vue&type=script&lang=ts"
import style0 from "./comp4.vue?vue&type=style&index=0&id=28c300ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c300ce",
  null
  
)

export default component.exports